import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M19.1811 17.7204H19.4141C19.7377 17.7204 20 17.9827 20 18.3063C20 18.6299 19.7377 18.8922 19.4141 18.8922H0.585938C0.262344 18.8922 0 18.6299 0 18.3063C0 17.9827 0.262344 17.7204 0.585938 17.7204H0.818906V10.8426C0.818906 10.519 1.08125 10.2567 1.40484 10.2567H5.90246V1.69531C5.90246 1.37172 6.1648 1.10938 6.4884 1.10938H13.5116C13.8352 1.10938 14.0975 1.37172 14.0975 1.69531V7.11105H18.5952C18.9188 7.11105 19.1811 7.3734 19.1811 7.69699V17.7204ZM1.99078 17.7204H5.90246V11.4286H1.99078V17.7204ZM7.07434 17.7204H12.9257V2.28125H7.07434V17.7204ZM14.0975 17.7204H18.0092V8.28293H14.0975V17.7204ZM10.7569 10.8873H10.9703C11.2939 10.8873 11.5562 11.1496 11.5562 11.4732C11.5562 11.7968 11.2939 12.0592 10.9703 12.0592H9.37222C9.04863 12.0592 8.78629 11.7968 8.78629 11.4732C8.78629 11.1496 9.04863 10.8873 9.37222 10.8873H9.585V9.41609L9.43789 9.51944C9.17312 9.70558 8.80769 9.64171 8.6216 9.37691C8.43554 9.11218 8.49933 8.74671 8.7641 8.56066L9.3248 8.16663C9.60351 7.97081 9.96441 7.94663 10.2668 8.1037C10.5691 8.26073 10.7569 8.56991 10.7569 8.91058V10.8873Z",
      fill: "#9C9C9C"
    }, null, -1)
  ])))
}